import { render, staticRenderFns } from "./AddWebPagesGroupManager.vue?vue&type=template&id=955aa2b6&scoped=true"
import script from "./AddWebPagesGroupManager.vue?vue&type=script&lang=ts"
export * from "./AddWebPagesGroupManager.vue?vue&type=script&lang=ts"
import style0 from "./AddWebPagesGroupManager.vue?vue&type=style&index=0&id=955aa2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955aa2b6",
  null
  
)

export default component.exports